import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PapAutoEvaluationComponent } from './pages/pap-autoevaluation/pap-autoevaluation.component';
import { PapPlanComponent } from './pages/pap-plan/pap-plan.component';
import { PapPlanDetailComponent } from './pages/pap-plan-detail/pap-plan-detail.component';
import { PapPortfolioComponent } from './pages/pap-portfolio/pap-portfolio.component';
import { PapPortfolioDetailComponent } from './pages/pap-portfolio-detail/pap-portfolio-detail.component';

const routes: Routes = [
  { path: '', redirectTo: 'portfolio', pathMatch: 'full' },
  { path: 'portfolio', component: PapPortfolioComponent },
  { path: 'portfolio/:id', component: PapPortfolioDetailComponent },
  { path: 'plan', component: PapPlanComponent },
  { path: 'plan/:id', component: PapPlanDetailComponent },
  { path: 'auto-evaluation', component: PapAutoEvaluationComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PapRoutingModule {}
